import * as firebase from "firebase/app";
import "firebase/firebase-firestore";
import "firebase/firebase-auth";
import "firebase/firebase-storage";
//import "firebase/firebase-messaging";
var config = {
    apiKey: "AIzaSyB5gVhJZSFHdaOdTT2KSPNIu2HXNI5AHhY",
    authDomain: "niochi-app.firebaseapp.com",
    databaseURL: "https://niochi-app.firebaseio.com",
    projectId: "niochi-app",
    storageBucket: "niochi-app.appspot.com",
    messagingSenderId: "972554203401"
};
firebase.initializeApp(config);

export default firebase;